import { createContext, useEffect } from "react";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";

import { getToken, removeToken, setToken } from "../utils/auth";
import { logout, resetAccountInfo } from "../actionCreator/commonActionCreator";
import { getUserInfo } from "../utils/utils";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { permissions } = getUserInfo();

  const checkSession = () => {
    const session = JSON.parse(localStorage.getItem("auth"));
    const currentTime = new Date().getTime();

    if (currentTime > session?.expiresAt) {
      logout();
      return false;
    }

    return true;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      checkSession();
    }, 1000 * 60);

    return () => clearInterval(interval);
  }, []);

  const login = (token, rememberMe) => {
    setToken(token, rememberMe);
  };

  const isWebToLeadDelete = permissions?.["Web To Leads"]?.find(
    (d) => d?.name === "Delete"
  );
  const isWebToLeadCreate = permissions?.["Web To Leads"]?.find(
    (d) => d?.name === "Create"
  );
  const isWebToLeadEdit = permissions?.["Web To Leads"]?.find(
    (d) => d?.name === "Edit"
  );
  const isWebToLeadView = permissions?.["Web To Leads"]?.find(
    (d) => d?.name === "View"
  );

  const isRMView = permissions?.["Reputation Manager"]?.find(
    (d) => d?.name === "View"
  );

  const isCompanyView = permissions?.["Company"]?.find(
    (d) => d?.name === "View"
  );

  const isLeadCreate = permissions?.["Leads"]?.find(
    (d) => d?.name === "Create"
  );
  const isLeadEdit = permissions?.["Leads"]?.find((d) => d?.name === "Edit");
  const isLeadView = permissions?.["Leads"]?.find((d) => d?.name === "View");

  const isExecutiveView = permissions?.["Executive"]?.find(
    (d) => d?.name === "View"
  );

  const isEmailSetupView = permissions?.["Email Setup"]?.find(
    (d) => d?.name === "View"
  );
  const isEmailSetupCreate = permissions?.["Email Setup"]?.find(
    (d) => d?.name === "Create"
  );

  const onLogout = async () => {
    dispatch(logout(getToken()));
    removeToken();
    dispatch(resetAccountInfo());
    navigate("/signin");
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated: !!getToken(),
        login,
        logout: onLogout,
        isWebToLeadDelete,
        isWebToLeadCreate,
        isWebToLeadEdit,
        isLeadCreate,
        isRMView,
        isCompanyView,
        isLeadView,
        isExecutiveView,
        isEmailSetupView,
        isLeadEdit,
        isWebToLeadView,
        isEmailSetupCreate,
        permissions,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
